import {WorkrequestDetailsBase} from '../data-objects/workrequest-details-base';

export class WorkrequestViewmodelBase {
  applicationDate: string;
  workrequestDetails: WorkrequestDetailsBase;

  constructor() {
    this.applicationDate = new Date().toLocaleDateString('en-AU');
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/viewmodels/workrequest-viewmodel-base.ts